export const admissionStatuses = [
  {
    val: 0,
    name: "Новый",
    step: 0
  },
  {
    val: 2,
    name: "Принято",
    step: 0
  }, {
    val: 3,
    name: "Отказано",
    step: 0
  }, {
    val: 5,
    name: "Отозвано",
    step: 0
  }, {
    val: 6,
    name: "Удалено",
    step: 0
  }, {
    val: 8,
    name: "Оценки подтверждены",
    step: 1
  }, {
    val: 20,
    name: "Экзамены",
    step: 2
  }, {
    val: 11,
    name: "Результаты",
    step: 2
  },
  {
    val: 21,
    name: "Готов к ранжированию",
    step: 3
  },
  {
    val: 22,
    name: "Ожидает ранжирования",
    step: 3
  },
  {
    val: 23,
    name: "Ранжирование завершено",
    step: 3
  },
  {
    val: 24,
    name: "Готов к зачислению",
    step: 4
  },
  {
    val: 26,
    name: "Отказался поступать",
    step: 3
  },
  {
    val: 27,
    name: "Группа назначена",
    step: 0
  },
  {
    val: 28,
    name: "Ожидает отправки",
    step: 3
  },
  {
    val: 29,
    name: "Отправлен на доработку",
    step: 2
  },
  {
    val: 30,
    name: "Прошел",
    step: 4
  },
  {
    val: 31,
    name: "Не прошел",
    step: 3
  },

  //зачислить
  {
    val: 32,
    name: "Оценки ожидают подтверждения",
    step: 1
  },
]
